// Shared page header — every view's title must render through this so the
// title/subtitle typography can never drift between pages. The spec is the
// Directory header (SearchBar.jsx was the source of truth before extraction).
export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="min-w-0">
      <h2 className="text-[22px] font-bold tracking-[-0.02em] leading-[1.1] text-[#3B5452] dark:text-white">
        {title}
      </h2>
      {(subtitle || children) && (
        <p className="text-[12.5px] text-ink-3 mt-1.5">
          {subtitle}
          {children}
        </p>
      )}
    </div>
  );
}
